module.exports = __webpack_public_path__ + "static/media/rSma.8f708db6.png";